import { resetMainView } from 'actions/mainView'
import { setActivePreview } from 'actions/preview'
import { resetPlaybackClip } from 'actions/playback'
import { reset as resetRecording } from 'reducers/recording'
import { updateSlider } from 'actions/timeline'
import { PLAYER_TYPE } from 'enums'


export const resetEditorBeforeProjectActivated = (
  projectId: string
) => async (dispatch: AppDispatch, getState: () => RootState) => {
  dispatch(resetMainView())
  dispatch(resetRecording())
  dispatch(resetPlaybackClip())
  dispatch(setActivePreview(PLAYER_TYPE.TIMELINE))
  if (!projectId) {
    dispatch(updateSlider(0))
  }
}
